import { useCallback, useState } from 'react';
import { AccountFast } from '../core/_models_fast';
import { LogOut } from 'lucide-react';
import { useAuth } from '../AuthContext';
import AccountSelect from '../components/AccountSelect';
import { setCurrentAccountUniqueIdentifierInLocalStorage } from '../core/_axios';

export const SelectCurrentAccountUniqueIdentifer = ({
    onSkipped
}: {
    onSkipped: () => void;
}) => {

    const {
        logout
    } = useAuth();

    const [continuing, setContinuing] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState<AccountFast | null>(null);

    const handleSelectedAccount = useCallback(async () => {
        if (!selectedAccount || continuing) {
            return;
        }
        setContinuing(true);
        setCurrentAccountUniqueIdentifierInLocalStorage(selectedAccount.unique_identifier);
        window.location.reload();
    }, [continuing, selectedAccount?.unique_identifier]);

    return (
        <div className="flex items-center justify-center grow bg-center bg-no-repeat page-bg min-h-screen relative">
            {/* Logout Icon */}
            <button
                onClick={() => {
                    logout();
                    window.location.href = '/'
                }}
                title="Logout"
                className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors flex items-center gap-2"
                style={{ zIndex: 10 }}
            >
                <LogOut size={22} className="text-black" />
                <span className="text-black text-sm font-medium">Logout</span>
            </button>
            <div className="card max-w-[420px] w-full">
                <div className="card-body flex flex-col gap-5 p-10">
                    <div className="text-center mb-2.5">
                        <h3 className="text-lg font-semibold text-gray-900 leading-none mb-2.5">
                            Select Account
                        </h3>
                        {false && <div className="flex items-center justify-center font-medium">
                            <span className="text-2sm text-gray-600 me-1.5">
                                Need an account?
                            </span>
                            <a className="text-2sm link" href="html/demo1/authentication/classic/sign-up.html">
                                Register account
                            </a>
                        </div>}
                    </div>
                    <div>
                        <AccountSelect
                            onChange={(selectedOption: AccountFast | null) => {
                                setSelectedAccount(
                                    selectedOption
                                )
                            }}
                        />
                    </div>
                    <div className="flex items-center justify-center">
                        <div className="text-gray-600 text-2sm text-center">
                            This account can be changed later.
                        </div>
                    </div>
                    <button
                        className="btn btn-primary flex justify-center grow"
                        type="button"
                        onClick={handleSelectedAccount}
                        disabled={continuing || !selectedAccount}
                    >
                        {!continuing ? `Continue` : `Continuing...`}
                    </button>
                    <div className="flex items-center justify-center">
                        <button
                            type="button"
                            onClick={() => {
                                onSkipped();
                            }}
                            className="btn btn-link"
                            style={{ cursor: 'pointer' }}
                        >
                            View All Accounts
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
};
